import React from 'react'
import Table from '../../components/Table'
import { apiClient } from '../../services/api-client'

interface Report {
  id: string
  name: string
  downloadUrl: string
  description?: string
  createdAt: Date
}

const REPORTS: Report[] = [
  {
    id: 'events-last-month',
    name: 'Events in the last month',
    downloadUrl: '/admin/reports/events-last-month',
    description: 'Analytics report for all venue specials with events in the last 30 days',
    createdAt: new Date('2025-12-28T10:26:41-06:00'),
  },
  {
    id: 'unique-daily-visits-and-peeks',
    name: 'Unique daily visits and peeks',
    downloadUrl: '/admin/reports/unique-daily-visits-and-peeks',
    description: 'Counts of unique visits and peeks per day',
    createdAt: new Date('2026-02-10T10:26:41-06:00'),
  },
  {
    id: 'internal-user-checkins',
    name: 'Internal user check-in times',
    downloadUrl: '/admin/reports/internal-user-checkins',
    description: 'Clock-in / clock-out style report for internal users (includes currently checked-in sessions)',
    createdAt: new Date('2026-04-17T00:00:00Z'),
  },
]

const ReportsPage = () => {
  const handleDownload = async (report: Report) => {
    try {
      const response = await apiClient.get(report.downloadUrl, {
        responseType: 'blob',
      })

      const contentDisposition = response.headers['content-disposition']
      let filename = `${report.name.replace(/\s+/g, '-')}.xlsx`

      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="(.+)"/)
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1]
        }
      }

      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)
    } catch (error) {
      console.error('Error downloading report:', error)
      alert('Failed to download report. Please try again.')
    }
  }

  return (
    <div>
      <div className="reports-container">
        <h2>Reports</h2>
        <Table
          id="reports"
          name="Reports"
          keyField="id"
          initialSortColumn="name"
          columns={[
            { label: 'Name', accessor: 'name', type: 'string' },
            { label: 'Description', accessor: 'description', type: 'string' },
            { label: 'Created', accessor: 'createdAt', type: 'datetime' },
          ]}
          sourceData={REPORTS}
          isPropertyBarVisible={false}
          filterTerms=""
          onRowClick={handleDownload}
        />
      </div>
    </div>
  )
}

export default ReportsPage
